import { ReactNode, lazy } from "react";

const Eruda = lazy(() =>
  import("./provider").then((c) => ({ default: c.Eruda }))
);

export const ErudaProvider = (props: { children: ReactNode }) => {
  // if (process.env.MODE === 'staging' || process.env.MODE === 'development' || window?.location?.search?.includes('?debug=1')) {
  //   return (
  //     <Suspense fallback={<div>Loading...</div>}>
  //       <Eruda>{props.children}</Eruda>
  //     </Suspense>
  //   );
  // }

  // return props.children;
  return <Eruda>{props.children}</Eruda>;
};
